<template>
	<div class="student-list-root">
		

		<div  class="web">
			<div class="header-card"
				style="margin-bottom:20px;padding:18px;border-radius:20px;box-shadow: 0 4px 16px rgba(0,0,0,0.06);">
				<h4 class="header-title" style="margin:0 0 14px 0;">
					班级学生（{{ totalData.totalStudent || 0 }}人）</h4>
				<el-radio-group v-model="statusFilter" @change="filterStudentList" size="small"
					style="margin-bottom: 14px;">
					<el-radio label="all">全部</el-radio>
					<el-radio label="online">在线</el-radio>
					<el-radio label="offline">退出</el-radio>
					<el-radio label="noline">未进入</el-radio>
				</el-radio-group>
				<div style="font-size:13px;color:#64748b;line-height:1.8;">
					<div style="margin-bottom: 8px; display: flex; gap: 10px; flex-wrap: wrap;">
						<span class="status-label status-online" title="在线">🟢
							{{ totalData.onlineCount || 0 }}人</span>
						<span class="status-label status-offline" title="离线">🔴
							{{ totalData.quitCount || 0 }}人</span>
						<span class="status-label status-noline" title="未进入">⚪{{ totalData.unOpenedCount || 0 }}人</span>
					</div>
					<div style="padding-top: 10px; border-top: 1px solid #e2e8f0; display: flex; gap: 16px; flex-wrap: wrap;">
						<span style="display: flex; align-items: center; gap: 4px;">💬
							学生输入：{{ totalData.totalStudentChat || 0 }}条</span>
						<span style="display: flex; align-items: center; gap: 4px;">AI回复：{{ totalData.totalAiChat || 0 }}条</span>
						<span style="display: flex; align-items: center; gap: 4px;">教师干预：{{ totalData.totalTeacherIntervene || 0 }}条</span>
					</div>
				</div>
			</div>
			<div v-for="item in filteredStudentList" :key="item.studentId"
				class="student-item-wrapper"
				:class="{ 
					'online': item.status === 1, 
					'offline': item.status === 2,
					'pulse': item.status === 1 && item.isNew,
					'selected': currentStudentId === item.studentId
				}"
				@click="handleSelectStudent(item)">
				<div style="display: inline-flex;align-items:center;gap:2px;">
					<span v-if="!isSave" class="lock-icon"
						:style="{color: item.controlStatus === 1 ? '#51cf66' : '#ff6b6b'}"
						@click.stop="handleLockStudent(item.studentId, item.controlStatus)">
						<i class="el-icon-unlock el-icon" v-if="item.controlStatus==0"></i>
						<i class="el-icon-lock el-icon" v-else></i>
					</span>
					<!-- <span  @click.stop="assignStudentPush(item.studentId)">推</span> -->
					<!-- <span  @click.stop="cancelStudentPush(item.studentId)">结</span> -->
					<div class="sensitive-badge" @click.stop="sensitiveNum(item)" title="敏感词数量">
						<img src="@/ico/stutas/sensitive.svg" class="sensitive-icon">
						<span class="sensitive-count">{{ item.sensitiveNum || 0 }}</span>
					</div>
					<!-- 2026-05-24 学生姓名容器 - 宽度缩小为75px，flex-shrink:0防止被压缩，确保表扬按钮能完整显示 -->
					<div style="width: 75px; flex-shrink: 0;">
			
						<el-button block 
							class="student-btn" 
							:class="{ 'is-primary': currentStudentId === item.studentId }">
							<!-- 2026-05-24 状态图标 - 使用status-icon-sm类，图标尺寸更小 -->
							<img v-if="item.status === 1" src="@/ico/stutas/online.svg" class="status-icon-sm" title="在线">
							<img v-if="item.status === 2" src="@/ico/stutas/exit.svg" class="status-icon-sm"
								title="退出">
							<img v-if="item.status === 0" src="@/ico/stutas/offline.svg" class="status-icon-sm" title="未加入">
			
							<!-- 2026-05-24 学生姓名 - 使用student-name-sm类，字体更小，宽度40px，超出显示省略号 -->
							<span class="student-name-sm">
								{{ item.studentName }}
							</span>
			
							<el-badge :value="`${item.studentChatCount+item.aiChatCount+item.teacherInterveneCount}`"
								size="mini" type="primary">
								<span style="visibility:hidden">·</span>
							</el-badge>
						</el-button>
					</div>
				</div>
			
				<!-- 2026-05-24 表扬按钮区域 - gap设置为3px，flex-shrink:0防止被压缩，确保按钮能完整显示 -->
				<div v-if="item.status === 1&&!isSave" class="praise-buttons" :data-student-id="item.studentId" style="
			  display: inline-flex; 
			  align-items: center; 
			  gap: 3px; 
			  white-space: nowrap; 
			  flex-shrink: 0;
			">
					<!-- 2026-05-27 点赞按钮 - 圆形样式，数字在右上角 -->
					<button class="praise-btn praise-thumb"
						@click.stop="handleSendPraise(item.studentId, item.studentName, 'thumb')"
						:class="{ active: item.praiseThumb }" title="点赞">
						<span class="praise-icon">👍</span>
						<span class="praise-count">{{ item.thumbCount || 0 }}</span>
					</button>
					<!-- 2026-05-27 送花按钮 - 圆形样式，数字在右上角 -->
					<button class="praise-btn praise-flower"
						@click.stop="handleSendPraise(item.studentId, item.studentName, 'flower')"
						:class="{ active: item.praiseFlower }" title="送鲜花">
						<span class="praise-icon">🌸</span>
						<span class="praise-count">{{ item.flowerCount || 0 }}</span>
					</button>
					<!-- 2026-05-27 送星星按钮 - 圆形样式，数字在右上角 -->
					<button class="praise-btn praise-star"
						@click.stop="handleSendPraise(item.studentId, item.studentName, 'star')"
						:class="{ active: item.praiseStar }" title="送星星">
						<span class="praise-icon">⭐</span>
						<span class="praise-count">{{ item.starCount || 0 }}</span>
					</button>
					<!-- 2026-05-27 加油按钮 - 圆形样式，数字在右上角 -->
					<button class="praise-btn praise-fist"
						@click.stop="handleSendPraise(item.studentId, item.studentName, 'fist')"
						:class="{ active: item.praiseFist }" title="加油">
						<span class="praise-icon">💪</span>
						<span class="praise-count">{{ item.fistCount || 0 }}</span>
					</button>
					<!-- 2026-05-24 取消表扬按钮 - 只在有任何表扬时显示，红色背景 -->
					<button v-if="item.praiseFlower || item.praiseThumb || item.praiseStar || item.praiseFist"
						class="praise-btn praise-cancel" @click.stop="handleCancelPraise(item.studentId)" title="取消表扬">
						<span class="praise-icon">✖</span>
					</button>
				</div>
			</div>
		</div>
		<div class="fixed-tour-btn">
		  <div class="tour-btn start-btn" v-if="!isClass&&!isSave" @click="forClass(1)">开始巡课</div>
		  <div class="tour-btn stop-btn" v-if='isClass&&!isSave' @click="forClass(0)">停止巡课</div>
		  <!-- 2026-07-29 课堂HTML分层统计入口：仅由父级判断 HTML 课堂后显示。 -->
		  <!-- <div class="tour-btn layer-stat-btn" v-if="showLayerStatButton" @click="$emit('open-layer-stat')">方法归类</div> -->
		</div>
		<!-- 敏感词记录弹窗 -->
		<el-dialog title="学生敏感词记录" :visible.sync="showSensitiveDialog" width="580px" center append-to-body>
			<div v-if="sensitiveList.length === 0 && sensitiveTotal === 0"
				style="text-align:center; padding:40px 0; color:#999;">
				暂无敏感词记录
			</div>
			<div v-else style="max-height:400px; overflow-y:auto;">
				<div v-for="(item, index) in sensitiveList" :key="index"
					style="padding:10px 12px; border-bottom:1px solid #f5f5f5; font-size:14px;">
					<div style="display:flex; justify-content:space-between; margin-bottom:4px;">
						<span style="color:#666;">{{ forTime(item.createTime) || '未知时间' }}</span>
						<span style="color:#ff4444; font-weight:bold;">{{ item.sensitiveWord || '敏感内容' }}</span>
					</div>
					<div style="font-size:12px; color:#999;">
						原文：{{ item.sendContent || '-' }}
					</div>
				</div>
			</div>

			<!-- 分页组件 -->
			<div style="margin-top:15px; text-align:right;">
				<el-pagination @current-change="sensitiveCurrentChange" :current-page="sensitivePageNum"
					:page-sizes="[10]" layout="total, prev, pager, next, jumper" :total="total" small>
				</el-pagination>
			</div>

			<div slot="footer" style="text-align:right;">
				<el-button @click="showSensitiveDialog = false">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		lockStudentStatus,
		postClassGlobalConfig
	} from './class.js'
	export default {
		name: 'StudentList',
		props: {
			// 父组件传入数据
			studentList: {
				type: Array,
				default: () => []
			},
			isSave: {
				type: Boolean,
				default: false
			},
			totalData: {
				type: Object,
				default: () => {}
			},
			patrolEnable:{
				type: Number,
				default:0
			},
			currentStudentId: [String, Number],
			courseClassId: [String, Number],
			schoolId: [String, Number],
			teacherId: [String, Number],
			device: [String, Number],
			showLayerStatButton: {
				// 2026-07-29 由课堂父页面确认 HTML 文件存在后传入，学生列表不自行请求课程配置。
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				statusFilter: 'all',
				filteredStudentList: [],
				sensitiveList: [],
				pageSize: 10,
				pageNum: 1,
				total: 0,
				studentId: '',
				showSensitiveDialog: false,
				sensitiveTotal: 0,
				sensitivePageNum: 1,
				isClass: false,
				currentStudentIndex: 0, // 当前正在展示的学生下标
				studentTimer: null // 定时器
			}
		},
		watch: {
			// 监听学生列表变化，自动刷新筛选
			studentList: {
				deep: true,
				handler() {
					this.filterStudentList()
				}
			},
			patrolEnable:{
				handler(val) {
					this.noforClass(val)
				}
			},
			
		},
		mounted() {
			this.filterStudentList()
		},
		beforeDestroy() {
			if (this.studentTimer) {
				clearInterval(this.studentTimer)
			}
		},
		methods: {
			forTime(val){
				var str=''
				if(val){
					str=val.replace("T","  ")
					if(str.indexOf(".")>-1){
						str=str.split('.')[0]
					}
				}
				return str
			},
			noforClass(value){
				if (value == 1) {
					this.isClass = true
					this.startAutoSwitchStudent()
				} else {
					this.isClass = false
					if (this.studentTimer) {
						clearInterval(this.studentTimer)
					}
				}
			},
			forClass(value) {
				if (value == 1) {
					this.isClass = true
					this.startAutoSwitchStudent()
				} else {
					this.isClass = false
					if (this.studentTimer) {
						clearInterval(this.studentTimer)
					}
				}
				
				this.postClassGlobalConfig(value)
				if(localStorage.getItem("PID")){
					alert('只在电脑端执行')
				}
			},
			postClassGlobalConfig(value){
				postClassGlobalConfig({
					"device": this.device,
					"courseClassId": this.courseClassId,
					"patrolEnable": value
				})
			},
			assignStudentPush(studentId){
				  console.log('点击推，学生ID：', studentId) // 新增日志
				  this.$emit('assignStudentPush',studentId)
			},
			cancelStudentPush(studentId){
				this.$emit('cancelStudentPush',studentId)
			},
			startAutoSwitchStudent() {
			  if (this.studentTimer) {
			    clearInterval(this.studentTimer)
			  }
			  
			  // 初始化从第一个开始
			  this.currentStudentIndex = -1
			
			  this.studentTimer = setInterval(() => {
			    this.forStudent()
			  }, 10000)
			},
			// 切换学生的核心方法
			forStudent() {
			  // 1. 只用【筛选后的在线学生列表】，保证下标正确
			  const onlineList = this.filteredStudentList.filter(item => item.status === 1)
			  
			  // 没有在线学生直接返回
			  if (!onlineList || onlineList.length === 0) {
			    return
			  }
			
			  // 2. 切换下标（只在在线学生里循环）
			  this.currentStudentIndex++
			  if (this.currentStudentIndex >= onlineList.length) {
			    this.currentStudentIndex = 0
			  }
			
			  // 3. 拿到当前要切换的学生
			  const currentStudent = onlineList[this.currentStudentIndex]
			  
			  // 4. 触发选中（关键！必须传完整学生对象）
			  this.handleSelectStudent(currentStudent,true)
			},
			sensitiveNum(student) {
				if (student.sensitiveNum == '0') return this.$message.success('暂无监听到敏感词！')
				this.studentId = student.studentId
				this.sensitiveList = []
				this.forList()

			},
			sensitiveCurrentChange(val) {
				this.pageNum = val
				this.forList()
			},
			forList() {
				this.API.get(this.API.student.getSensitiveStudentPage, {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					schoolId: this.schoolId,
					studentId: this.studentId,
					courseId: this.courseClassId
				}).then(res => {
					this.sensitiveList = res.data.data.content
					this.total = res.data.data.totalElements
					this.showSensitiveDialog = true
				}).catch(err => {
					this.sensitiveList = []
				})
			},

			// 筛选学生
			filterStudentList() {
				if (this.statusFilter === 'all') {
					this.filteredStudentList = [...this.studentList]
				} else if (this.statusFilter === 'online') {
					this.filteredStudentList = this.studentList.filter(item => item.status === 1)
				} else if (this.statusFilter === 'noline') {
					this.filteredStudentList = this.studentList.filter(item => item.status === 0)
				} else if (this.statusFilter === 'offline') {
					this.filteredStudentList = this.studentList.filter(item => item.status === 2)
				}
			},

			// 选择学生（向父组件抛事件）
			handleSelectStudent(student, isAutoSwitch = false) {
			  // 巡课自动切换，不做取消逻辑
			  if (isAutoSwitch) {
			    localStorage.setItem('studentId', student)
			    this.$emit('select-student', student, isAutoSwitch)
			    return
			  }
				console.log('student',student.studentId)
				console.log('this.currentStudentId',this.currentStudentId)
			  // 手动点击：当前已选中则取消，否则选中
			  if (this.currentStudentId === student.studentId) {
			    localStorage.removeItem('studentId')
			    this.$emit('select-student', null, false)
			  } else {
			    localStorage.setItem('studentId', student)
			    this.$emit('select-student', student, false)
			  }
			},

			// 单个学生锁定（向父组件抛事件）
			handleLockStudent(studentId, currentControlStatus) {
				this.$emit('lock-student', studentId, currentControlStatus)
			},

			// 发送表扬
			handleSendPraise(studentId, studentName, praiseType) {
				this.$emit('send-praise', studentId, studentName, praiseType)
			},

			// 取消表扬
			handleCancelPraise(studentId) {
				this.$emit('cancel-praise', studentId)
			},
		}
	}
</script>

<style scoped>
	/* 把你原来的所有样式完整复制过来 */
	
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}
	.student-list-root {
	  position: relative; /* 定位基准 */
	  height: 100%;
	}
	.web {
	  height: 100%;
	  max-height: calc(100dvh - 60px); /* dvh 是平板/手机专用正确高度 */
	  overflow-y: auto;
	  -webkit-overflow-scrolling: touch;
	}
	.el-badge {
		margin-left: 4px !important;
	}

	.el-button:hover {
		opacity: 0.9;
		transition: all 0.2s;
	}

	/* 2026-05-24 滚动条样式 - 自定义浏览器滚动条外观 */
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	/* 2026-05-24 滚动条滑块 - 浅灰色，圆角设计 */
	::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background: #cbd5e1;
	}

	/* 2026-05-24 滚动条轨道 - 浅背景色 */
	::-webkit-scrollbar-track {
		background: #f1f5f9;
		border-radius: 3px;
	}

	/* 2026-05-24 头部卡片 - 渐变背景色，带圆角和阴影 */
	.header-card {
		background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
		border: 1px solid #e2e8f0 !important;
	}

	/* 2026-05-24 标题样式 - 16px加粗字体 */
	.header-title {
		font-size: 16px !important;
		color: #1e293b !important;
		font-weight: 600 !important;
	}

	/* 2026-05-24 状态标签基础样式 - 小标签，带间距 */
	.status-label {
		font-size: 13px;
		font-weight: 500;
		padding: 4px 10px;
		border-radius: 12px;
		display: inline-flex;
		align-items: center;
		gap: 4px;
	}

	/* 2026-05-24 在线状态 - 绿色渐变背景 */
	.status-online {
		background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
		color: #16a34a;
	}

	/* 2026-05-24 离线状态 - 红色渐变背景 */
	.status-offline {
		background: linear-gradient(135deg, #ffaa00 0%, #ffaa00 100%);
		color: #fff;
	}

	/* 2026-05-24 未进入状态 - 灰色渐变背景 */
	.status-noline {
		background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
		color: #6b7280;
	}

	/* 2026-05-24 学生项包裹器 - 主容器，带相对定位用于在线状态圆点 */
	.student-item-wrapper {
		position: relative;
		margin-bottom: 6px;
		background: #ffffff;
		border-radius: 10px;
		padding: 6px 10px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, 0.03);
		transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
		animation: fadeInUp 0.4s ease forwards;
		cursor: pointer;
		border: 1px solid transparent;
		display: flex;
		align-items: center;
		gap: 6px;
		flex-wrap: nowrap;
		
		
	}

	/* 2026-05-24 选中状态样式 - 蓝色渐变背景，左边有蓝色装饰条，高亮显示 */
	.student-item-wrapper.selected {
		background: linear-gradient(135deg, #f8fbff 0%, #e8f4ff 100%) !important;
		border: 3px solid #0ea5e9 !important;
		box-shadow: 0 8px 25px rgba(14, 165, 233, 0.15), inset 4px 0 0 #0ea5e9 !important;
		transform: translateY(-2px);
	}

	/* 2026-05-24 悬停状态 - 轻微上浮，阴影加深 */
	.student-item-wrapper:hover {
		transform: translateY(-3px);
		box-shadow: 0 10px 30px rgba(102, 126, 234, 0.12);
		border-color: rgba(102, 126, 234, 0.15);
	}

	/* 2026-05-24 在线状态（非选中）- 绿色渐变背景，左边有绿色装饰条 */
	.student-item-wrapper.online:not(.selected) {
		background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
		box-shadow: inset 4px 0 0 #22c55e;
	}

	/* 2026-05-24 在线状态指示器 - 左侧绿色小圆点，带脉冲动画 */
	.student-item-wrapper.online::before {
		content: '';
		position: absolute;
		left: -1px;
		top: 50%;
		transform: translateY(-50%);
		width: 8px;
		height: 8px;
		background: #22c55e;
		border-radius: 50%;
		box-shadow: 0 0 8px rgba(34, 197, 94, 0.5);
		animation: status-pulse 2s ease-in-out infinite;
	}

	/* 2026-05-24 离线状态（非选中）- 半透明，灰色背景，左边有灰色装饰条 */
	.student-item-wrapper.offline:not(.selected) {
		opacity: 0.55;
		background: #fafafa;
		box-shadow: inset 4px 0 0 #9ca3af;
	}

	/* 2026-05-24 离线状态名字 - 灰色显示 */
	.student-item-wrapper.offline:not(.selected) .student-name {
		color: #9ca3af;
	}

	/* 2026-05-24 状态脉冲动画 - 在线状态圆点的呼吸效果 */
	@keyframes status-pulse {
		0%, 100% {
			opacity: 1;
			transform: translateY(-50%) scale(1);
		}
		50% {
			opacity: 0.6;
			transform: translateY(-50%) scale(0.85);
		}
	}

	/* 2026-05-24 淡入上移动画 - 学生项加载时的入场动画 */
	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(20px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* 2026-05-24 绿色脉冲动画 - 新加入学生时的高亮效果 */
	@keyframes pulse-green {
		0%, 100% {
			box-shadow: 0 0 0 0 rgba(81, 207, 102, 0.4);
		}
		50% {
			box-shadow: 0 0 0 8px rgba(81, 207, 102, 0);
		}
	}

	/* 2026-05-24 新加入学生动画 - 组合入场动画和绿色脉冲 */
	.student-item-wrapper.online.pulse {
		animation: fadeInUp 0.4s ease forwards, pulse-green 1.5s ease infinite;
	}

	.student-row {
		display: flex;
		align-items: center;
		gap: 6px;
		background: #fff;
		border-radius: 6px;
		padding: 4px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	}

	/* 2026-05-24 锁定图标 - 可点击的锁定/解锁按钮 */
	.lock-icon {
		cursor: pointer;
		font-size: 18px;
		padding: 2px;
	}

	/* 2026-05-24 学生按钮 - 主按钮，包含状态图标、姓名和徽章 */
	.student-btn {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 3px;
		padding: 3px 5px;
		border: 1px solid #e2e8f0 !important;
		background: #ffffff !important;
		cursor: pointer;
		text-align: left;
		border-radius: 5px;
		transition: all 0.2s ease;
	}

	/* 2026-05-24 学生按钮悬停 - 蓝色边框和背景 */
	.student-btn:hover {
		border-color: #44c1f4 !important;
		background: #f0f9ff !important;
	}

	/* 2026-05-24 学生按钮选中 - 蓝色背景 */
	.student-btn.is-primary {
		background: #44c1f4 !important;
		border-color: #44c1f4 !important;
	}

	/* 2026-05-24 选中状态名字 - 白色文字 */
	.student-btn.is-primary .student-name {
		color: #ffffff !important;
	}

	/* 2026-05-24 学生姓名基础样式 - 大字号版本 */
	.student-name {
		flex: 1;
		font-size: 14px;
		font-weight: 500;
		color: #333;
	}

	/* 2026-05-24 学生姓名小字号版本 - 宽度固定40px，超出省略，用于紧凑布局 */
	.student-name-sm {
		flex: 1;
		font-size: 11px;
		font-weight: 500;
		color: #333;
		width: 40px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-left: 2px;
	}

	/* 2026-05-24 选中状态小字号名字 - 白色文字 */
	.student-btn.is-primary .student-name-sm {
		color: #ffffff !important;
	}

	/* 2026-05-24 小状态图标 - 12px尺寸 */
	.status-icon-sm {
		width: 12px;
		height: 12px;
		vertical-align: middle;
	}

	.status-text {
		font-size: 12px;
	}

	.praise-buttons-inline {
		display: flex;
		gap: 3px;
		flex-shrink: 0;
	}

	/* 2026-05-24 表扬按钮 - 圆角胶囊按钮，渐变色背景，带阴影 */
	/* 2026-05-27 表扬按钮 - 圆形样式，图标居中 */
	.praise-btn {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		padding: 0;
		border: none;
		border-radius: 50%;
		background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		font-size: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	}

	/* 2026-05-24 表扬按钮悬停 - 轻微上浮，阴影加深 */
	.praise-btn:hover {
		transform: translateY(-1px);
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
	}

	/* 2026-05-24 选中状态下的表扬按钮 - 白色背景，蓝色边框 */
	.student-item-wrapper.selected .praise-btn {
		background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
		border: 1px solid #d0e8ff;
	}

	/* 2026-05-27 表扬图标 - 18px emoji图标，居中显示 */
	.praise-icon {
		font-size: 18px;
		line-height: 1;
		position: relative;
		z-index: 1;
	}

	/* 2026-05-27 表扬计数 - 数字在右上角，红色圆角标签 */
	.praise-count {
		position: absolute;
		top: -4px;
		right: -4px;
		min-width: 16px;
		height: 16px;
		padding: 0 4px;
		background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
		color: #fff;
		font-size: 10px;
		font-weight: 600;
		text-align: center;
		line-height: 16px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
		z-index: 2;
	}

	.praise-btn-mini {
		display: flex;
		align-items: center;
		gap: 2px;
		padding: 6px 10px;
		border: none;
		border-radius: 20px;
		background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		font-size: 15px;
		min-width: 36px;
		justify-content: center;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	}

	.praise-btn-mini:hover {
		transform: translateY(-2px) scale(1.05);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
		background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
	}

	.praise-btn-mini.active {
		color: #fff;
		animation: praise-pulse 0.3s ease;
		transform: translateY(-2px);
		box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
	}

	/* 2026-05-27 点赞按钮激活状态 - 红色渐变 */
	.praise-thumb.active {
		background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
		box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
	}

	/* 2026-05-27 送花按钮激活状态 - 粉色渐变 */
	.praise-flower.active {
		background: linear-gradient(135deg, #ff69b4 0%, #ff85c1 100%);
		box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);
	}

	/* 2026-05-27 送星按钮激活状态 - 金色渐变 */
	.praise-star.active {
		background: linear-gradient(135deg, #ffd700 0%, #ffdb4d 100%);
		box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
	}

	/* 2026-05-27 加油按钮激活状态 - 青色渐变 */
	.praise-fist.active {
		background: linear-gradient(135deg, #4ecdc4 0%, #6ee7df 100%);
		box-shadow: 0 4px 15px rgba(78, 205, 196, 0.4);
	}

	/* 2026-05-24 弹跳动画 - 表扬按钮点击时的缩放效果 */
	@keyframes bounce {
		0%, 100% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.2);
		}
	}

	/* 2026-05-24 粉色发光动画 - 送花按钮的脉冲效果 */
	@keyframes glow-pink {
		0%, 100% {
			box-shadow: 0 0 0 0 rgba(255, 107, 157, 0.4);
		}
		50% {
			box-shadow: 0 0 15px 5px rgba(255, 107, 157, 0.2);
		}
	}

	/* 2026-05-24 橙色发光动画 - 点赞按钮的脉冲效果 */
	@keyframes glow-orange {
		0%, 100% {
			box-shadow: 0 0 0 0 rgba(255, 169, 64, 0.4);
		}
		50% {
			box-shadow: 0 0 15px 5px rgba(255, 169, 64, 0.2);
		}
	}

	/* 2026-05-24 黄色发光动画 - 送星按钮的脉冲效果 */
	@keyframes glow-yellow {
		0%, 100% {
			box-shadow: 0 0 0 0 rgba(255, 212, 59, 0.4);
		}
		50% {
			box-shadow: 0 0 15px 5px rgba(255, 212, 59, 0.2);
		}
	}

	/* 2026-05-24 蓝色发光动画 - 加油按钮的脉冲效果 */
	@keyframes glow-blue {
		0%, 100% {
			box-shadow: 0 0 0 0 rgba(105, 192, 255, 0.4);
		}
		50% {
			box-shadow: 0 0 15px 5px rgba(105, 192, 255, 0.2);
		}
	}

	/* 2026-05-24 取消表扬按钮 - 淡红背景，红色文字 */
	.praise-cancel {
		background: #fff0f0;
		color: #ff4d4f;
		font-size: 12px;
	}

	/* ===== 响应式适配 ===== */

	/* 2026-05-24 手机端 (max-width: 767px) - 最紧凑布局，适合小屏幕 */
	@media (max-width: 767px) {
		.student-item-wrapper {
			margin-bottom: 5px;
			padding: 4px 5px;
			border-radius: 8px;
			gap: 4px;
		}

		.student-btn {
			padding: 2px 4px;
			gap: 2px;
			min-width: 65px;
		}

		.student-name {
			font-size: 10px;
			width: 35px;
		}

		.status-icon {
			width: 10px !important;
			height: 10px !important;
		}

		.praise-buttons {
			gap: 1px !important;
			flex-shrink: 0;
		}

		.praise-btn {
			padding: 2px 4px;
			min-width: 22px;
			font-size: 10px;
			border-radius: 8px;
		}

		.praise-icon {
			font-size: 10px;
		}

		.praise-count {
			font-size: 8px;
			min-width: 10px;
		}

		.lock-icon {
			font-size: 12px;
		}

		.sensitive-badge {
			transform: scale(0.7);
		}

		.sensitive-icon {
			width: 10px;
			height: 10px;
		}

		.sensitive-count {
			font-size: 8px;
			min-width: 10px;
			height: 10px;
			line-height: 10px;
		}
	}

	/* 2026-05-24 平板端 (768px - 1024px) - 中等尺寸，适合平板屏幕 */
	@media (min-width: 768px) and (max-width: 1024px) {
		.student-item-wrapper {
			margin-bottom: 6px;
			padding: 6px 8px;
			border-radius: 10px;
			gap: 6px;
		}

		.student-btn {
			padding: 3px 5px;
			gap: 3px;
			min-width: 75px;
		}

		.student-name {
			font-size: 12px;
			width: 40px;
		}

		.status-icon {
			width: 14px !important;
			height: 14px !important;
		}

		.praise-buttons {
			gap: 3px !important;
		}

		.praise-btn {
			padding: 3px 6px;
			min-width: 26px;
			font-size: 12px;
		}

		.praise-icon {
			font-size: 12px;
		}

		.praise-count {
			font-size: 10px;
			min-width: 14px;
		}

		.lock-icon {
			font-size: 16px;
		}
	}

	/* 2026-05-24 PC端 (min-width: 1025px) - 最大尺寸，适合桌面屏幕 */
	@media (min-width: 1025px) {
		.student-item-wrapper {
			margin-bottom: 6px;
			padding: 6px 10px;
			border-radius: 10px;
			gap: 6px;
		}

		.student-btn {
			padding: 3px 5px;
			gap: 3px;
			min-width: 75px;
		}

		.student-name {
			font-size: 12px;
			width: 40px;
		}

		.status-icon {
			width: 15px !important;
			height: 15px !important;
		}

		.praise-buttons {
			gap: 3px !important;
		}

		.praise-btn {
			padding: 3px 6px;
			min-width: 28px;
			font-size: 12px;
		}

		.praise-icon {
			font-size: 12px;
		}

		.praise-count {
			font-size: 10px;
			min-width: 14px;
		}

		.lock-icon {
			font-size: 18px;
		}
	}

	/* 2026-05-24 取消表扬按钮悬停 - 红色加深 */
	.praise-cancel:hover {
		background: #ffccc7;
	}

	.praise-count-mini {
		font-size: 10px;
		font-weight: 600;
		min-width: 14px;
		text-align: center;
	}

	/* 2026-05-24 表扬脉冲动画 - 表扬按钮的缩放效果 */
	@keyframes praise-pulse {
		0% {
			transform: scale(1);
		}

		50% {
			transform: scale(1.15);
		}

		100% {
			transform: scale(1);
		}
	}

	@media (max-width: 768px) {
		.student-row {
			gap: 4px;
			padding: 3px;
		}

		.lock-icon {
			font-size: 14px;
		}

		.student-btn {
			padding: 4px 6px;
			gap: 4px;
		}

		.student-name {
			font-size: 12px;
		}

		.status-text {
			font-size: 10px;
		}

		.praise-btn-mini {
			padding: 3px 4px;
			font-size: 12px;
			min-width: 24px;
		}

		.praise-count-mini {
			font-size: 8px;
			min-width: 12px;
		}
	}

	@media (min-width: 769px) and (max-width: 1024px) {
		.praise-btn-mini {
			padding: 3px 5px;
			font-size: 13px;
		}
	}

	/* 2026-05-24 状态图标 - 15px基础尺寸 */
	.status-icon {
		width: 15px;
		height: 15px;
		vertical-align: middle;
	}

	/* 2026-05-24 敏感词徽章 - 点击可查看敏感词详情 */
	.sensitive-badge {
		position: relative;
		width: 24px;
		height: 24px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		border: none;
		background: transparent;
		padding: 0;
		margin: 0 2px;
	}

	/* 2026-05-24 敏感词图标 - 20px尺寸 */
	.sensitive-icon {
		width: 20px;
		height: 20px;
		object-fit: contain;
	}

	/* 2026-05-24 敏感词计数 - 红色徽章，绝对定位在图标上 */
	.sensitive-count {
		position: absolute;
		top: -10%;
		left: 10%;
		font-size: 11px;
		font-weight: bold;
		color: #fff;
		background-color: #ff4444;
		border-radius: 3px;
		padding: 1px 2px;
		line-height: 1.2;
		min-width: 3;
		text-align: center;
	}

	/* 2026-05-24 巡课按钮样式 - 底部固定按钮 */
	/* 底部固定按钮 */
/* 2026-07-29 课堂底部操作入口样式：巡课和方法归类按钮统一尺寸，适配桌面/平板/手机。 */
.fixed-tour-btn {
  position: absolute;
  left: 0;
  bottom: 0px; /* 核心：根容器底部向下偏移50px */
  width: 100%;
  min-height: 80px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  pointer-events: none;
}
.tour-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 112px;
  min-height: 40px;
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  pointer-events: auto;
  box-shadow: 0 10px 20px rgba(30, 80, 150, .16);
  transition: transform .18s ease, box-shadow .18s ease;
}
.tour-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(30, 80, 150, .22);
}
.start-btn {
  background-color: #409eff;
}
.stop-btn {
  background-color: #ff7a21;
}
.layer-stat-btn {
  background: linear-gradient(135deg, #2f80ed 0%, #12b5cb 100%);
  box-shadow: 0 8px 18px rgba(18, 181, 203, .22);
}

@media (max-width: 1024px) {
  .fixed-tour-btn {
    left: auto;
    right: 0;
    width: min(80vw, 380px);
    padding: 14px;
  }
}

@media (max-width: 560px) {
  .fixed-tour-btn {
    left: 0;
    right: 0;
    width: 100%;
    min-height: 68px;
    padding: 12px;
  }

  .tour-btn {
    flex: 1 1 120px;
    min-width: 0;
    font-size: 14px;
  }
}
</style>
